export const INSPECTION_TYPE = {
    LP1: "적합성검사",
    LP2: "조음검사",
} as const;

export const INSPECTION_NAME = {
    LANGUAGE: "언어",
} as const;

export const INSPECTION_STATUS = {
    PAYMENT_COMPLETED: "결제완료",
    CAN_RE_EXAM: "재검사하기",
    EXAM_COMPLETED: "검사완료",
    WAIT_FOR_PAYMENT: "입금대기",
    REFUND_COMPLETED: "환불완료",
    EXAM_IN_PROGRESS: "검사중",
    CANCELLED: "결제취소",
    ABORTED: "검사중단",
    CRASHED: "비정상종료",
} as const;

export const INSPECTION_VALID = {
    VALID: "적합",
    INVALID: "부적합",
} as const;

/**
 * @name INSPECTION_PVC_THRESHOLD
 * @description 검사 통과 점수 모음정확도를 기준으로 75% 이상 시 유효로 판단합니다.
 * @default 75
 */
export const INSPECTION_PVC_THRESHOLD = 75;

/**
 * @name INSPECTION_PRICE
 * @description LP 조음검사 비용
 */
export const INSPECTION_PRICE = 20000;

/**
 * @name INSPECTION_OVERALL_THRESHOLD
 * @description LP 조음검사 종합점수 기준
 */
export const INSPECTION_OVERALL_THRESHOLD = 30;

/**
 * @name INSPECTION_RE_EXAM_MAX_COUNT
 * @description LP 조음검사 재검사 가능 최대 횟수
 */
export const INSPECTION_RE_EXAM_MAX_COUNT = 2;
